import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import TopNavigation from '../TopNavigation';
import ClueRaiderBanner from '../components/ClueRaiderBanner';
import { blogPosts } from './blogPosts';

const Blog: React.FC = () => {
  useEffect(() => {
    const title = "Director's Blog - Dimension Flux";
    const description = "Insights, puzzles, and behind-the-scenes stories from the Flux Directorate";
    const url = "https://dimensionflux.com/blog";
    
    document.title = title;
    
    // Update or create meta tags
    const updateMetaTag = (property: string, content: string, isProperty = true) => {
      const attribute = isProperty ? 'property' : 'name';
      let meta = document.querySelector(`meta[${attribute}="${property}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute(attribute, property);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    };

    // Open Graph tags
    updateMetaTag('og:title', title);
    updateMetaTag('og:description', description);
    updateMetaTag('og:image', 'https://dimensionflux.com/res.png?v=5');
    updateMetaTag('og:url', url);
    updateMetaTag('og:type', 'website');
    updateMetaTag('og:site_name', 'Dimension Flux');

    // Twitter Card tags
    updateMetaTag('twitter:card', 'summary_large_image', false);
    updateMetaTag('twitter:title', title, false);
    updateMetaTag('twitter:description', description, false);
    updateMetaTag('twitter:image', 'https://dimensionflux.com/res.png?v=4', false);
    updateMetaTag('twitter:site', '@dimensionflux', false);
    updateMetaTag('twitter:creator', '@dimensionflux', false);

    // Standard meta description
    updateMetaTag('description', description, false);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 text-white">
      <TopNavigation />
      <ClueRaiderBanner />

      <div className="pt-2 pb-2 px-2 sm:pt-2 sm:pb-4 sm:px-4">
        <div className="max-w-xl mx-auto w-full">
          <div className="bg-white bg-opacity-95 rounded-lg p-2 sm:p-4 border-2 border-gray-300 shadow-lg mb-4 sm:mb-6 w-full">
            <div className="text-center mb-4">
              <h1 className="text-2xl sm:text-3xl font-oswald font-bold text-gray-900 mb-2">Director's Blog</h1>
              <p className="text-base font-lora text-gray-700 italic">
                Insights, puzzles, and behind-the-scenes stories from the Flux Directorate
              </p>
            </div>

            <div className="space-y-4">
              {blogPosts.map((post) => (
                <Link
                  key={post.slug}
                  to={`/blog/${post.slug}`}
                  className="block bg-gray-50 rounded-lg p-3 sm:p-4 border border-gray-200 hover:border-gray-400 hover:shadow-md transition-all duration-200"
                >
                  <div className="flex gap-4">
                    {post.image && (
                      <div className="flex-shrink-0">
                        <img 
                          src={post.image} 
                          alt={post.title}
                          className="w-24 h-24 sm:w-32 sm:h-32 object-cover rounded-lg border border-gray-200"
                        />
                      </div>
                    )}
                    <div className="flex-1 min-w-0">
                      <h2 className="text-lg sm:text-xl font-oswald font-bold mb-2 text-gray-900 leading-tight">
                        {post.title}
                      </h2>
                      <div className="text-sm text-gray-600 mb-3">
                        {new Date(post.date).toLocaleDateString('en-US', { 
                          year: 'numeric', 
                          month: 'long', 
                          day: 'numeric' 
                        })} • {post.author}
                      </div>
                      <p className="text-gray-700 text-sm sm:text-base leading-relaxed font-lora">
                        {post.excerpt}
                      </p>
                      {post.isSpecial && (
                        <span className="inline-block mt-3 px-3 py-1 bg-gray-800 text-white text-xs rounded-full">
                          Interactive Feature
                        </span>
                      )}
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blog;

